import { Injectable } from "@angular/core";
import { SampleApiUrlUtil } from "@sharedcommon/util/sample-service.util";
import { Observable } from "rxjs";
import { NeqHttpClient } from "@sharedcommon/rest/http-client.config";
import { SharedPagedResponse } from "@sharedcommon/model/shared-paged-response.model";
import { SpeciesFilterDto } from "@sharedcommon/model/sample/filter/species-filter.model";
import { SpeciesDto } from "@sharedcommon/model/sample/species.model";

@Injectable({ providedIn: 'root'})
export class SpeciesRestService {
  constructor(private neqHttpClient: NeqHttpClient){}

  /**
   * Search species
   * Response code 200 - Paged result
   * Response code 500 - Error
   * HTTP GET species/search
   * Java method: com.neovia.services.sample.controller.SpeciesController.search
   */
  search(filterDto: SpeciesFilterDto): Observable<SharedPagedResponse<SpeciesDto>> {
    return this.neqHttpClient.request({ method: 'GET', url: SampleApiUrlUtil.formatApiUrl(`species/search`), data: filterDto });
  }
}